export class MarcheAlerte {
  constructor(
    public uuid: string,
    public seuilAlerte: number,
    public alerteDateFinPeriode?: Date,
    public alerteDateFinDeRennonciation?: Date
  ) {}

  static adapt(item: any): MarcheAlerte {
    return new MarcheAlerte(
      item.uuid,
      item.seuilAlerte,
      item.alerteDateFinPeriode ? new Date(item.alerteDateFinPeriode) : undefined,
      item.alerteDateFinDeRennonciation ? new Date(item.alerteDateFinDeRennonciation) : undefined
    );
  }
}
